module.exports = __webpack_public_path__ + "static/service-banner-message-eabc259d0bf1fb561b8c912a3fdf64fd.jpeg";